import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UploadStrategyBase } from '@utilities/manual-upload-strategies/upload-strategy-base';
import { merge, Subscription, tap } from 'rxjs';

@Component({
    selector: 'lex-manual-upload',
    templateUrl: './manual-upload.component.html',
    styleUrls: ['./manual-upload.component.scss'],
    standalone: false
})
export class ManualUploadComponent extends KeyHandlerDirective implements OnInit, OnDestroy {
	public strategy: UploadStrategyBase;
	public alert: string;
	public canUpload = true;
	public selectedFile: File;
	private alertSubscription: Subscription;

	constructor(
		private dialogRef: MatDialogRef<ManualUploadComponent>,
		@Inject(MAT_DIALOG_DATA) data: { strategy: UploadStrategyBase }
	) {
		super();
		this.strategy = data.strategy;
	}

	public ngOnInit() {
		this.alertSubscription = merge(
			this.strategy.warning$(),
			this.strategy.error$().pipe(
				tap((message) => {
					this.canUpload = !message;
				})
			)
		).subscribe((message) => {
			this.alert = message;
		});
	}

	public ngOnDestroy() {
		this.alertSubscription.unsubscribe();
	}

	public fileSelected(files: FileList) {
		this.selectedFile = files[0];
	}

	public ok(): void{
		this.strategy.tryUpload(this.selectedFile).subscribe((result) => {
			if (result) {
				this.alert = result;
			}
			else {
				this.dialogRef.close(true);
			}
		});
	}
}
